import { BringzzIcon } from "@bringzz/components";

const PermissionRequest = ({ onRequestPermission }) => {
    return (
        <div className="absolute inset-0 bg-white/80 backdrop-blur-sm flex items-center justify-center z-20">
            <div className="bg-white p-6 rounded-xl shadow-lg max-w-md text-center">
                <BringzzIcon
                    icon="IconLocation"
                    folder="LineIcons"
                    size="48"
                    className="mx-auto mb-4"
                />
                <h2 className="text-xl font-semibold mb-2">Location Access Required</h2>
                <p className="text-gray-600 mb-4">
                    Please allow access to your location to use the map features.
                </p>
                <button
                    onClick={onRequestPermission}
                    className="bg-magic-lilac text-white px-6 py-2 rounded-lg hover:bg-magic-lilac transition-colors"
                >
                    Enable Location Access
                </button>
            </div>
        </div>
    );
};

export default PermissionRequest;
